export const EShapeCircle = wcardinal.ui.EShapeCircle;